import {dataHooks} from '@wix/data-hooks'

export const reservationsFormDataHooks = dataHooks<{
  root: {}
  location: {}
  partySize: {}
  date: {}
  time: {}
}>('reservations-form')
